import { TFunction } from 'i18next';
import formatApproxDuration from '@lib/utils/formatApproxDuration';

// `estimatedFinishAt` is an absolute ISO8601 timestamp; derive the remaining
// time from it (self-correcting between throttled progress frames).
const getProgressDuration = (
  estimatedFinishAt: string | null | undefined,
  t: TFunction,
): string => {
  if (!estimatedFinishAt) return '';

  const eta = (new Date(estimatedFinishAt).getTime() - Date.now()) / 1000;
  const duration = formatApproxDuration(eta, t);

  return duration ? `~${duration}` : '';
};

export default getProgressDuration;
